import {ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {UrlStorageService} from '@app/services/utility/url-storage.service';

@Injectable({
  providedIn: 'root',
})
export class SuccessUrlGuard {
  constructor(private urlStorageService: UrlStorageService) {}

  readonly SUCCESS_URL_KEY = 'successUrl';

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const successUrl: string = state.root.queryParams[this.SUCCESS_URL_KEY];
    this.urlStorageService.storeValidUrlInLocalStorage(this.SUCCESS_URL_KEY, successUrl);
    return of(true);
  }
}
